<template>
    <div>
        <div class="top">
            <div class="topleft">
                <el-breadcrumb separator="/">
                    <el-breadcrumb-item v-if="this.user.user.roles[0].id == 1" :to="{ path: '/home' }">{{$t('home')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>{{$t('re1')}}</el-breadcrumb-item>
                    <el-breadcrumb-item>放款报表</el-breadcrumb-item>
                </el-breadcrumb>
            </div>
        </div>
        <div class="cont">
            <div class="listbox">
                <div class="listright" v-loading="loading">
                    <div class="searchleft">
                        <el-form :inline="true" :model="searchform" class="demo-form-inline" @submit.native.prevent >
                            <el-form-item :label="$t('channel')">
                                <el-select size="small" v-model="searchform.blurry" multiple :placeholder="$t('qxz')" style="width:150px">
                                    <el-option v-for="item in typeList"
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.name">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="App">
                                <el-select v-model="searchform.app" @change="onAppChange" placeholder="请选择" style="width:150px">
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option label="Aktivaku" value="Aktivaku"></el-option>
                                    <el-option label="Sanders" value="Sanders"></el-option>
                                    <el-option label="papitupi" value="papitupi"></el-option>
                                    <el-option label="Igrow" value="Igrow"></el-option>
                                    <el-option label="DanaBijak" value="DanaBijak"></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="子产品">
                                <el-select v-model="searchform.platform" :disabled="filteredPlatforms.length === 0" placeholder="请选择" style="width:150px">
                                    <el-option :label="$t('buxian')" :value="null"></el-option>
                                    <el-option
                                        v-for="item in filteredPlatforms"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                    />
                                </el-select>
                            </el-form-item>
                            <el-form-item label="放款时间">
                                <el-date-picker
                                    v-model="value1"
                                    type="daterange"
                                    size="small"
                                    @change="checkdata"
                                    range-separator="至"
                                    value-format="yyyy-MM-dd"
                                    start-placeholder="开始时间"
                                    end-placeholder="结束时间">
                                </el-date-picker>
                            </el-form-item>
                            <el-form-item>
                                <el-button size="small" type="primary" @click="onSubmit">{{$t('query')}}</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="top"></div>
                    <el-table :data="list" :header-cell-style="{'background':'#f5f5f5','font-weight':'bold','color':'#555555','padding':'6px 0'}" style="width: 100%">
                        <el-table-column prop="date" label="日期"></el-table-column>
                        <el-table-column prop="loan_disbursement_amount" label="放款数"></el-table-column>
                        <el-table-column prop="contract_amount" label="合同金额(人民币)"></el-table-column>
                        <el-table-column prop="loan_principal_amount" label="放款本金(人民币)"></el-table-column>	
                        <el-table-column prop="extension_number" label="展期数"></el-table-column>	
                        <el-table-column prop="extension_amount" label="展期金额(人民币)"></el-table-column>	
                        <el-table-column prop="new_customer_count" label="新客数"></el-table-column>	
                        <el-table-column prop="existing_customer_count" label="老客数"></el-table-column>
                        <el-table-column prop="new_customer_amount" label="新客金额(人民币)"></el-table-column>	
                        <el-table-column prop="existing_customer_amount" label="老客金额(人民币)"></el-table-column>	
                        <el-table-column prop="existing_customer_amount_ratio" label="老客金额占比"></el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import apiurl from "@/api/public"
    import _api from "@/api/index"
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import {
        LOAD_CHILDREN_OPTIONS
    } from '@riophae/vue-treeselect'
    export default {
        components: {
            Treeselect
        },
        data() {
            var rolesValid = (rule, value, callback) => {
                callback()
            }
            return {
                form: {
                    id: null,
                    phone: null,
                    userName: null,
                    email: null,
                    channel: null,
                },
                searchform: {
                    blurry: null,
                    app:"",
                    platform:"",
                },
                loading: false,
                showadd: false,
                phone:null,
                list: [],
                value1:null,
                typeList: [],
                platformOptions: [
                    { label: "GraDana", value: "GraDana", app: "Aktivaku" },
                    { label: "AwanTunai", value: "AwanTunai", app: "Aktivaku" },
                    { label: "Aktivaku", value: "Aktivaku", app: "Aktivaku" },
                    { label: "PinjamModal", value: "PinjamModal", app: "Aktivaku" },


                    { label: "IKIModal", value: "IKIModal", app: "Sanders" },
                    { label: "Ethis", value: "Ethis", app: "Sanders" },
                    { label: "Sanders", value: "Sanders", app: "Sanders" },
                    { label: "Akseleran", value: "Akseleran", app: "Sanders" },

                    { label: "Duha", value: "Duha", app: "papitupi" },
                    { label: "komunal", value: "komunal", app: "papitupi" },
                    { label: "papitupi", value: "papitupi", app: "papitupi" },
                    { label: "Ammana", value: "Ammana", app: "papitupi" },

                    { label: "Qazwa", value: "Qazwa", app: "Igrow" },
                    { label: "Restock", value: "Restock", app: "Igrow" },
                    { label: "Igrow", value: "Igrow", app: "Igrow" },

                    { label: "DanaMerdeka", value: "DanaMerdeka", app: "DanaBijak" },
                    { label: "DanaSyariah", value: "DanaSyariah", app: "DanaBijak" },
                    { label: "DanaBijak", value: "DanaBijak", app: "DanaBijak" },
                ]
            }
        },
        created() {
            this.user=JSON.parse(localStorage.getItem("userinfo"))
            this.value1 = this.getNowTime()
            this.getTypeList()
            this.getList()
        },
        computed: {
            filteredPlatforms() {
                if (!this.searchform.app) return []; // 默认空
                return this.platformOptions.filter(item => item.app === this.searchform.app);
            }
        },
        methods: {
            onAppChange() {
                this.searchform.platform = null; // 切换 app 时清空子产品
            },
            getNowTime() {
                // const start = new Date(new Date().getTime() - 3600 * 1000 * 24 * 7)
                //     .toISOString()
                //     .replace('T', ' ')
                //     .split('.')[0] //默认开始时间7天前
                // const end = new Date(new Date().getTime() + 3600 * 1000 * 24 * 1)
                //     .toISOString()
                //     .replace('T', ' ')
                //     .split('.')[0]//默认结束时间1天前
                // return [start, end]

                // 计算时间范围（本地时间）
                const now = Date.now();
                const startDate = new Date(now - 7 * 86400000); // 7天前
                const endDate = new Date(now + 1 * 86400000);   // 1天后

                // 本地时间格式化函数
                const formatLocalDate = (date) => {
                    return [
                    date.getFullYear(),
                    String(date.getMonth() + 1).padStart(2, '0'),
                    String(date.getDate()).padStart(2, '0')
                    ].join('-');
                };

                return [formatLocalDate(startDate), formatLocalDate(endDate)];
            },
            getTypeList() {
                _api.get(apiurl.typeList, {
                }).then(res => {
                    this.typeList = res.data
                })
            },
            getList() {
                this.loading = true
                if (this.value1 == null) {
                    this.$message.error(this.$t('tel87'))
                    return
                }

                const type = null; 
                if (this.searchform.blurry != null) {
                    this.type = this.searchform.blurry.join(",")
                }

                _api.get(apiurl.loaninfo, {
                    type: this.type,
                    createTime: this.value1,
                    app: this.searchform.app,
                    platform: this.searchform.platform,
                }).then(res => {
                    this.loading = false
                    this.list = res.data
                })
            },
            onSubmit() {
                this.getList()
            },
        }
    }
</script>
<style scoped>
    .lefttop {
        padding: 8px;
    }

    .listbox {
        display: flex;
    }

    .listleft {
        width: 20%;
        border: 1px solid #EBEEF5;
    }

    .listright {
        width: 100%;
        margin-left: 1%;
    }

    .top {
        margin-top: 15px;
    }

    .listrighttop {
        padding: 0 10px;
        background: rgb(245, 245, 245);
        height: 40px;
        overflow: hidden;
        line-height: 40px;
        border-bottom: 1px solid #EBEEF5;
    }

    .listrighttop strong {
        float: left;
    }

    .listrighttop span {
        float: right;
    }

    ::v-deep .vue-treeselect__control,
    ::v-deep .vue-treeselect__placeholder,
    ::v-deep .vue-treeselect__single-value {
        height: 30px;
        line-height: 30px;
    }
</style>